'use client'

import { Col, Row } from 'antd'
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import { useRouter } from 'next/navigation'
import { CarouselModel } from '~types/search'

import Carousel from '@mercadoni/sinister/dist/cjs/shared/components/Carousel'
import { ClientModel } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'

import useInteractions from '../../DynamicHome/hooks/useInteractions'

const CarouselsRow = (props: {
  carousels: CarouselModel[]
  clientConfig: ClientModel
}) => {
  const router = useRouter()
  const widgetInteractionLogic = useInteractions({
    clientConfig: props.clientConfig,
    router: router as unknown as AppRouterInstance,
  })

  if (props.carousels.length === 0) return null

  return (
    <Row style={{ marginBottom: 16 }}>
      {props.carousels.map((carousel: CarouselModel) => (
        <Col span={24} key={carousel.id}>
          <Carousel
            key={carousel.id}
            interactions={widgetInteractionLogic}
            carousel={carousel}
          />
        </Col>
      ))}
    </Row>
  )
}

export default CarouselsRow
